<template>
  <v-dialog v-if="dialog"  v-model="dialog" :max-width="options.width" @keydown.esc="cancel()">
    <div @mouseover='hover' @mouseleave='hover'>
    <v-toolbar dark :color="options.color" dense>
      <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card tile>
      <v-card-text  v-show="!options.html"><span style="white-space: pre-wrap;">{{ message }}</span></v-card-text>
      <v-card-text  v-html="message" v-show="options.html"><span style="white-space: pre-wrap;"></span></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text @click.native="agree()">{{options.ok ? options.ok : 'Yes'}}</v-btn>
        <v-btn v-if="!options.nocancel" color="grey" text @click.native="cancel()">{{options.cancel ? options.cancel : 'Cancel'}}</v-btn>
      </v-card-actions>
    </v-card>
    </div>
  </v-dialog>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        title: null,
        hovering: false,
        timedOut: false,
        options: {
          color: 'primary',
          width: 290,
          html: false,
          timeout: 0
        }
      }
    },
    methods: {
      hover (val) {
        if (val.type == 'mouseover') {
          this.hovering = true
        } else if (val.type == 'mouseleave') {
          this.hovering  = false
          if (this.timedOut) this.cancel()
        }
      },
      open (title, message, options) {
        this.hovering = false
        this.timedOut = false
        this.dialog = true
        this.title = title
        this.message = message
        this.options.nocancel = false
        if (!options.width) options.width = 290
        this.options = Object.assign(this.options, options)
        var self = this
        if (this.options.timeout != 0) {
          setTimeout(function() {
            if (!self.hovering) self.cancel()
            self.timedOut = true
          }, this.options.timeout)
        }
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },
      agree () {
        this.resolve(true)
        this.dialog = false
      },
      cancel () {
        this.resolve(false)
        this.dialog = false
      },
      mounted () {
        this.timedOut = false
        this.hovering = false
      }
    }
  }
</script>